import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=0b1c83d8"
import script from "./BillingSummary.vue?vue&type=script&lang=js"
export * from "./BillingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports